import ReportsList from 'components/reports-list';
import { kf1I18nString } from 'kfone-frontend-core';
import './index.css';

const RecentReportsComponent = () => {
  return (
    <div className='recent-reports-container' data-testid='recent-reports-container'>
      <div className='border-b-2 pb-[12px] text-ods-font-styles-heading-small'>
        {kf1I18nString('pe.landingPage.recentReports')}
      </div>
      <div className='recent-reports-content'>
        <ReportsList isRecentReport />
      </div>
    </div>
  );
};

export default RecentReportsComponent;
